import { render, staticRenderFns } from "./MainSidebarMenu.vue?vue&type=template&id=3c1e11e1"
import script from "./MainSidebarMenu.vue?vue&type=script&lang=js"
export * from "./MainSidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarMenu.vue?vue&type=style&index=0&id=3c1e11e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports